import {
  useMutation,
  useQuery,
  useQueryClient,
  UseQueryResult,
} from "@tanstack/react-query";
import { useEffect } from "react";
import useNotificationHandler from "hooks/useNotificationHandler";
import { QUERY_KEYS } from "library/shared";
import {
  CascoCondition,
  CreateCascoConditionRequest,
  CreateCascoConditionResponse,
  UpdateCascoConditionsRequest,
  UpdateInsurerCascoConditionsRequest,
} from "library/types/cascoConditions";
import api from "service/api";

const CASCO_CONDITIONS_API_BASE = "settings/cascoconditions";

// const defaultCascoConditions: CascoCondition[] = [
//   {
//     name: "Noteikumi",
//     insurerConditions: [
//       {
//         insurerName: "Balta",
//         insurerText: "Nosaukto risku Nr. 2101.Z02",
//       },
//       {
//         insurerName: "BAN",
//         insurerText: "KASKO visu risku noteikumi Nr. 71.06.",
//       },
//       {
//         insurerName: "Ergo",
//         insurerText: "Nosaukto risku Nr. KA 11-2020",
//       },
//       {
//         insurerName: "IF",
//         insurerText: "Nosaukto risku Nr. TMH-20231",
//       },
//       {
//         insurerName: "Gjensidige",
//         insurerText: "Nosaukto risku Nr. 4.9.",
//       },
//       {
//         cascoConditionInsurerId: 6,
//         cascoConditionId: 1,
//         insurerName: "BTA",
//         insurerText: "Visu risku noteikumi Nr. 4F6",
//       },
//       {
//         cascoConditionInsurerId: 7,
//         cascoConditionId: 1,
//         insurerName: "Compensa",
//         insurerText: "Visu risku Nr. KASKO",
//       },
//       {
//         cascoConditionInsurerId: 8,
//         cascoConditionId: 1,
//         insurerName: "Balcia",
//         insurerText: "Noteikumi Nr. LV-03/01-03",
//       },
//     ],
//   },
//   {
//     name: "Drošības sistēmu prasības",
//     insurerConditions: [
//       {
//         insurerName: "Balta",
//         insurerText:
//           "Skaņas un gaismas signalizācija, rūpnīcas imobilaizers un citas drošības sistēmas saskaņā ar apdrošinātāja prasībām.",
//       },
//       {
//         insurerName: "BAN",
//         insurerText:
//           "Skaņas un gaismas signalizācija, rūpnīcas imobilaizers un citas drošības sistēmas saskaņā ar apdrošinātāja prasībām.",
//       },
//       {
//         insurerName: "Ergo",
//         insurerText:
//           "Skaņas un gaismas signalizācija, rūpnīcas imobilaizers un citas drošības sistēmas saskaņā ar apdrošinātāja prasībām.",
//       },
//       {
//         insurerName: "IF",
//         insurerText:
//           "Skaņas un gaismas signalizācija, rūpnīcas imobilaizers un citas drošības sistēmas saskaņā ar apdrošinātāja prasībām.",
//       },
//       {
//         insurerName: "Gjensidige",
//         insurerText:
//           "Skaņas un gaismas signalizācija, rūpnīcas imobilaizers un citas drošības sistēmas saskaņā ar apdrošinātāja prasībām.",
//       },
//       {
//         insurerName: "BTA",
//         insurerText:
//           "Skaņas un gaismas signalizācija, rūpnīcas imobilaizers un citas drošības sistēmas saskaņā ar apdrošinātāja prasībām.",
//       },
//       {
//         insurerName: "Compensa",
//         insurerText:
//           "Skaņas un gaismas signalizācija, rūpnīcas imobilaizers un citas drošības sistēmas saskaņā ar apdrošinātāja prasībām.",
//       },
//       {
//         insurerName: "Balcia",
//         insurerText:
//           "Skaņas un gaismas signalizācija, rūpnīcas imobilaizers un citas drošības sistēmas saskaņā ar apdrošinātāja prasībām.",
//       },
//     ],
//   },
//   {
//     cascoConditionId: 3,
//     name: "Keyless go sistēma",
//     insurerConditions: [
//       {
//         insurerName: "Balta",
//         insurerText:
//           "Transportlīdzeklim, kas aprīkots ar kādu no bezkontakta atslēgas sistēmām, un transportlīdzeklis nav aprīkots ar elektronisku aizdedzes pārtraucēju (papildus imobilaizers) Zādzības, Laupīšanas riskam var tikt noteikts pašrisks 15% apmērā, vai zādzības, laupīšanas risks var nebūt spēkā",
//       },
//       {
//         insurerName: "BAN",
//         insurerText:
//           "Transportlīdzeklim, kas aprīkots ar kādu no bezkontakta atslēgas sistēmām, un transportlīdzeklis nav aprīkots ar elektronisku aizdedzes pārtraucēju (papildus imobilaizers) Zādzības, Laupīšanas riskam tiek noteikts pašrisks 20% apmērā.",
//       },
//       {
//         insurerName: "Ergo",
//         insurerText:
//           "Transportlīdzeklim, kas aprīkots ar kādu no bezkontakta atslēgas sistēmām, un transportlīdzeklis nav aprīkots ar elektronisku aizdedzes pārtraucēju (papildus imobilaizers) Zādzības, Laupīšanas riskam tiek noteikts pašrisks 15% apmērā",
//       },
//       {
//         insurerName: "IF",
//         insurerText:
//           "Transportlīdzeklim, kas aprīkots ar kādu no bezkontakta atslēgas sistēmām, un transportlīdzeklis nav aprīkots ar elektronisku aizdedzes pārtraucēju (papildus imobilaizers) Zādzības, Laupīšanas riskam tiek noteikts pašrisks 20% apmērā.",
//       },
//       {
//         insurerName: "Gjensidige",
//         insurerText:
//           "Transportlīdzeklim kura vērtība pārsniedz 10000 EUR un tas ir aprīkots ar kādu no bezkontakta atslēgas sistēmām, un transportlīdzeklis nav aprīkots ar elektronisku aizdedzes pārtraucēju (papildus imobilaizers) tad zādzības risks nav spēkā.",
//       },
//       {
//         insurerName: "BTA",
//         insurerText:
//           "Transportlīdzeklim, kas aprīkots ar kādu no bezkontakta atslēgas sistēmām, un transportlīdzeklis nav aprīkots ar elektronisku aizdedzes pārtraucēju (papildus imobilaizers) Zādzības, Laupīšanas riskam tiek noteikts pašrisks 15% apmērā.",
//       },
//       {
//         insurerName: "Compensa",
//         insurerText:
//           "Transportlīdzeklim, kas aprīkots ar kādu no bezkontakta atslēgas sistēmām, un transportlīdzeklis nav aprīkots ar elektronisku aizdedzes pārtraucēju (papildus imobilaizers) Zādzības, Laupīšanas riskam tiek noteikts pašrisks 15% apmērā.",
//       },
//       {
//         insurerName: "Balcia",
//         insurerText:
//           "Transportlīdzeklim, kas aprīkots ar kādu no bezkontakta atslēgas sistēmām, un transportlīdzeklis nav aprīkots ar elektronisku aizdedzes pārtraucēju (papildus imobilaizers) Zādzības, Laupīšanas riskam tiek noteikts pašrisks 15% apmērā.",
//       },
//     ],
//   },
//   {
//     cascoConditionId: 4,
//     name: "Piemaksa / atlaide par izmainītu polises darbības teritoriju",
//     insurerConditions: [
//       {
//         insurerName: "Balta",
//         insurerText: "Piemaksa par NVS, atlaide par Baltiju, Latviju",
//       },
//       {
//         insurerName: "BAN",
//         insurerText: "Piemaksa par NVS, atlaide par Baltiju",
//       },
//       {
//         insurerName: "Ergo",
//         insurerText:
//           "Piemaksa par NVS, Īriju, Lielbritāniju un Maltu, atlaide par Baltiju, Latviju",
//       },
//       {
//         insurerName: "IF",
//         insurerText: "Piemaksa par NVS, atlaide par Baltiju, Latviju",
//       },
//       {
//         insurerName: "Gjensidige",
//         insurerText: "Piemaksa par NVS, Īriju, Lielbritāniju un Maltu",
//       },
//       {
//         insurerName: "BTA",
//         insurerText: "Piemaksa par NVS, atlaide par Baltiju, Latviju",
//       },
//       {
//         insurerName: "Compensa",
//         insurerText:
//           "Piemaksa par NVS (izņemot Moldovu) un Turciju, atlaide par Baltiju, Latviju",
//       },
//       {
//         insurerName: "Balcia",
//         insurerText: "Piemaksa par NVS",
//       },
//     ],
//   },
//   {
//     cascoConditionId: 5,
//     name: "Palīdzības karte",
//     insurerConditions: [
//       {
//         insurerName: "Balta",
//         insurerText: "Balta-Palīdzības karte",
//       },
//       {
//         insurerName: "BAN",
//         insurerText: "BAN-Palīdzības karte",
//       },
//       {
//         insurerName: "Ergo",
//         insurerText: "Ergo-Palīdzības karte",
//       },
//       {
//         insurerName: "IF",
//         insurerText: "IF-Palīdzības karte",
//       },
//       {
//         insurerName: "Gjensidige",
//         insurerText: "Gjensidige-Palīdzības karte",
//       },
//       {
//         insurerName: "BTA",
//         insurerText: "BTA-Palīdzības karte",
//       },
//       {
//         insurerName: "Compensa",
//         insurerText: "Compensa-Palīdzības karte",
//       },
//       {
//         insurerName: "Balcia",
//         insurerText: "Balcia-Palīdzības karte",
//       },
//     ],
//   },
//   {
//     cascoConditionId: 6,
//     name: "Transportlīdzekļa lietotāja vecums un stāžs (ietekme uz atlīdzības apmēru)",
//     insurerConditions: [
//       {
//         insurerName: "Balta",
//         insurerText:
//           "Ja apdrošinājuma ņēmējs ir juridiska persona - ierobežojumu nav, bet ja apdrošinājuma ņēmējs ir fiziska persona - atlīdzība var tikt samazināta par 20%, ja negadījuma brīdī pie stūres būs bijusi persona, kas jaunāka par polisē norādīto jaunāko lietotāju.",
//       },
//       {
//         insurerName: "BAN",
//         insurerText:
//           "Atlīdzība var tikt samazināta par 20%, ja negadījuma brīdī pie stūres būs bijusi persona, kas jaunāka par polisē norādīto jaunāko lietotāja vecumu un stāžu.",
//       },
//       {
//         insurerName: "Ergo",
//         insurerText:
//           "Ja apdrošinājuma ņēmējs ir juridiska persona un negadījuma brīdī pie stūres būs persona, kura ir jaunāka par 28 gadiem (ieskaitot) un tas nav norādīts polisē, tiek atlīdzināti 80% no zaudējuma, atskaitot pašrisku. Ja polisē norādīti konkrēti lietotāji un negadījuma brīdī pie stūres būs bijusi persona, tiek atlīdzināti 50% no zaudējuma, atskaitot pašrisku. Ja apdrošinājuma ņēmējs ir fiziska persona, notiekot ceļu satiksmes negadījumam, transportlīdzekli ir vadījusi persona, kas ir jaunāka kā apdrošināšanas piedāvājumā norādītā vai ar mazāku B kategorijas transportlīdzekļa vadītāja stāžu, kā norādīts apdrošināšanas piedāvājumā, Apdrošinātājs atlīdzina 80% no aprēķinātās apdrošināšanas atlīdzības, atskaitot apdrošināšanas polisē norādīto pašrisku",
//       },
//       {
//         insurerName: "IF",
//         insurerText:
//           "Ja negadījuma brīdī pie stūres būs bijusi persona, kuras braukšanas stāžs ir mazāks par 2 gadiem vai kura tiek apmācīta, pašrisks tiek piemērots divkāršā apmērā.",
//       },
//       {
//         insurerName: "Gjensidige",
//         insurerText:
//           "Atlīdzība var tikt samazināta par 20%, bet ne mazāk par 150 EUR, ja negadījuma izraisītājs būs bijusi persona, kuras vecums un/vai vadītāja stāžs ir mazāks kā polisē norādītais.",
//       },
//       {
//         insurerName: "BTA",
//         insurerText:
//           "Ja apdrošinājuma ņēmējs ir juridiska persona - ierobežojumu nav. Ja apdrošinājuma ņēmējs ir fiziska persona - Ja a/m lietos persona, kura a/m vadītāja B kategorijas stāžs mazāks nekā 3 pilni gadi, tad apdrošināšanas atlīdzība par CSNg. risku tiks samazināta par 20%.",
//       },
//       {
//         insurerName: "Compensa",
//         insurerText:
//           "Atlīdzība var tikt samazināta par 20%, bet ne mazāk kā 140 EUR, ja negadījuma brīdī pie stūres būs bijusi persona, kas jaunāka nekā polisē norādītā jaunākā lietotāja vecums.",
//       },
//       {
//         insurerName: "Balcia",
//         insurerText:
//           "Atlīdzība var tikt samazināta, ja negadījuma izraisītājs būs bijusi persona, kuras vadītāja stāžs ir mazāks kā polisē norādītais.",
//       },
//     ],
//   },
//   {
//     cascoConditionId: 7,
//     name: "Serviss, kurā veic remontu pēc negadījuma",
//     insurerConditions: [
//       {
//         insurerName: "Balta",
//         insurerText:
//           "Apdrošinātāja izvēlēts. Par papildus maksu klienta izvēlēts serviss. Par papildus maksu polisē var iekļaut dīleri līdz 7 gadiem.",
//       },
//       {
//         insurerName: "BAN",
//         insurerText:
//           "Klienta izvēlēts, izņemot dīleri. Par piemaksu – remonts pie dīlera servisiem.",
//       },
//       {
//         insurerName: "Ergo",
//         insurerText:
//           "Klienta izvēlēts, izņemot dīleri. Par papildus maksu Polisē var iekļaut dīleri līdz 8 g.",
//       },
//       {
//         insurerName: "IF",
//         insurerText: "Klienta izvēlēts, izņemot dīleri.",
//       },
//       {
//         insurerName: "Gjensidige",
//         insurerText: "Klienta izvēlēts, izņemot dīleri",
//       },
//       {
//         insurerName: "BTA",
//         insurerText: "Apdrošinātāja izvēlēts",
//       },
//       {
//         insurerName: "Compensa",
//         insurerText:
//           "Klienta izvēlēts, izņemot dīleri. Par piemaksu - dīleris jebkura vecuma tr/l.",
//       },
//       {
//         insurerName: "Balcia",
//         insurerText: "Klienta izvēlēts, izņemot dīleri",
//       },
//     ],
//   },
//   {
//     cascoConditionId: 8,
//     name: "Aizvietošana, pēc KASKO gadījuma",
//     insurerConditions: [
//       {
//         insurerName: "Balta",
//         insurerText: "Iekļauts. Limits 7dienas / 14 dienas / 30 dienas",
//       },
//       {
//         insurerName: "BAN",
//         insurerText: "Iekļauts līdz 15 dienām ar limitu 30 EUR diennaktī",
//       },
//       {
//         insurerName: "Ergo",
//         insurerText:
//           "Iekļauts. Limits 30 dienas polises darbības laikā, 15 dienas vienam gadījumam. 29 EUR dienā.",
//       },
//       {
//         insurerName: "IF",
//         insurerText:
//           "Iekļauts, bez dienu limita iestājoties bojājumu negadījumam. Bojāejas un zādzības gadījumā 30 dienas.",
//       },
//       {
//         insurerName: "Gjensidige",
//         insurerText: "Iekļauts. Limits 7 dienas / 15 dienas / 30 dienas",
//       },
//       {
//         insurerName: "BTA",
//         insurerText: "Iekļauts. Limits 15 dienas / 30 EUR Dienā",
//       },
//       {
//         insurerName: "Compensa",
//         insurerText: "Iekļauts. Limits 20 dienas / 30 EUR dienā",
//       },
//       {
//         insurerName: "Balcia",
//         insurerText: "Iekļauts. Limits 30 dienas",
//       },
//     ],
//   },
//   {
//     cascoConditionId: 9,
//     name: "Pašriska nepiemērošana, ja ir notikusi sadursme ar dzīvnieku, un par to ir paziņots policijai",
//     insurerConditions: [
//       {
//         insurerName: "Balta",
//         insurerText: "Pašrisks netiek piemērots",
//       },
//       {
//         insurerName: "BAN",
//         insurerText: "Pašrisks netiek piemērots",
//       },
//       {
//         insurerName: "Ergo",
//         insurerText: "Pašrisks netiek ieturēts, vienu reizi polises periodā",
//       },
//       {
//         insurerName: "IF",
//         insurerText: "Pašrisks netiek piemērots",
//       },
//       {
//         insurerName: "Gjensidige",
//         insurerText: "Pašrisks netiek piemērots",
//       },
//       {
//         insurerName: "BTA",
//         insurerText: "Pašrisks netiek piemērots",
//       },
//       {
//         insurerName: "Compensa",
//         insurerText: "Pašrisks netiek piemērots",
//       },
//       {
//         insurerName: "Balcia",
//         insurerText: "Pašrisks tiek piemērots",
//       },
//     ],
//   },
//   {
//     cascoConditionId: 10,
//     name: "Degvielas sajaukšanas risks (Degvielas padeves sistēmas tīrīšanas izdevumi)",
//     insurerConditions: [
//       {
//         insurerName: "Balta",
//         insurerText: "Iekļauts",
//       },
//       {
//         insurerName: "BAN",
//         insurerText: "Pašrisks netiek piemērots",
//       },
//       {
//         insurerName: "Ergo",
//         insurerText: "Iekļauts",
//       },
//       {
//         insurerName: "IF",
//         insurerText: "Iekļauts",
//       },
//       {
//         insurerName: "Gjensidige",
//         insurerText: "Iekļauts",
//       },
//       {
//         insurerName: "BTA",
//         insurerText: "Iekļauts",
//       },
//       {
//         insurerName: "Compensa",
//         insurerText: "Iekļauts, 500 EUR",
//       },
//       {
//         insurerName: "Balcia",
//         insurerText: "Iekļauts",
//       },
//     ],
//   },
//   {
//     cascoConditionId: 11,
//     name: "Bojājumi, kas radušies saistībā ar transportlīdzekļa mazgāšanu, apkopi vai remontu, vai to sekām",
//     insurerConditions: [
//       {
//         insurerName: "Balta",
//         insurerText: "Iekļauts",
//       },
//       {
//         insurerName: "BAN",
//         insurerText: "Pašrisks netiek piemērots",
//       },
//       {
//         insurerName: "Ergo",
//         insurerText: "Iekļauts (Jāziņo par notikušo policijai)",
//       },
//       {
//         insurerName: "IF",
//         insurerText: "Iekļauts",
//       },
//       {
//         insurerName: "Gjensidige",
//         insurerText: "Iekļauts",
//       },
//       {
//         insurerName: "BTA",
//         insurerText: "Iekļauts",
//       },
//       {
//         insurerName: "Compensa",
//         insurerText: "Iekļauts (Par notikušo ir jāziņo valsts policijai)",
//       },
//       {
//         insurerName: "Balcia",
//         insurerText: "Iekļauts",
//       },
//     ],
//   },
//   {
//     cascoConditionId: 12,
//     name: "Pašriska piemērošana NVS teritorijā",
//     insurerConditions: [
//       {
//         insurerName: "Balta",
//         insurerText: "Balta-Pašriska piemērošana NVS teritorijā",
//       },
//       {
//         insurerName: "BAN",
//         insurerText: "BAN-Pašriska piemērošana NVS teritorijā",
//       },
//       {
//         insurerName: "Ergo",
//         insurerText: "Ergo-Pašriska piemērošana NVS teritorijā",
//       },
//       {
//         insurerName: "IF",
//         insurerText: "IF-Pašriska piemērošana NVS teritorijā",
//       },
//       {
//         insurerName: "Gjensidige",
//         insurerText: "Gjensidige-Pašriska piemērošana NVS teritorijā",
//       },
//       {
//         insurerName: "BTA",
//         insurerText: "BTA-Pašriska piemērošana NVS teritorijā",
//       },
//       {
//         insurerName: "Compensa",
//         insurerText: "Compensa-Pašriska piemērošana NVS teritorijā",
//       },
//       {
//         insurerName: "Balcia",
//         insurerText: "Balcia-Pašriska piemērošana NVS teritorijā",
//       },
//     ],
//   },
//   {
//     cascoConditionId: 13,
//     name: "Pašrisks apzagšanas gadījumā (tr/l daļu zādzība)",
//     insurerConditions: [
//       {
//         insurerName: "Balta",
//         insurerText: "Balta-Pašrisks apzagšanas gadījumā (tr/l daļu zādzība)",
//       },
//       {
//         insurerName: "BAN",
//         insurerText: "BAN-Pašrisks apzagšanas gadījumā (tr/l daļu zādzība)",
//       },
//       {
//         insurerName: "Ergo",
//         insurerText: "Ergo-Pašrisks apzagšanas gadījumā (tr/l daļu zādzība)",
//       },
//       {
//         insurerName: "IF",
//         insurerText: "IF-Pašrisks apzagšanas gadījumā (tr/l daļu zādzība)",
//       },
//       {
//         insurerName: "Gjensidige",
//         insurerText:
//           "Gjensidige-Pašrisks apzagšanas gadījumā (tr/l daļu zādzība)",
//       },
//       {
//         insurerName: "BTA",
//         insurerText: "BTA-Pašrisks apzagšanas gadījumā (tr/l daļu zādzība)",
//       },
//       {
//         insurerName: "Compensa",
//         insurerText:
//           "Compensa-Pašrisks apzagšanas gadījumā (tr/l daļu zādzība)",
//       },
//       {
//         insurerName: "Balcia",
//         insurerText: "Balcia-Pašrisks apzagšanas gadījumā (tr/l daļu zādzība)",
//       },
//     ],
//   },
//   {
//     cascoConditionId: 14,
//     name: "Atlīdzība gadījumā, ja tr/l tiek nozagts kopā ar dokumentiem, atslēgu, drošības sistēmu pultīm, kartēm",
//     insurerConditions: [
//       {
//         insurerName: "Balta",
//         insurerText:
//           "Balta-Atlīdzība gadījumā, ja tr/l tiek nozagts kopā ar dokumentiem, atslēgu, drošības sistēmu pultīm, kartēm",
//       },
//       {
//         insurerName: "BAN",
//         insurerText:
//           "BAN-Atlīdzība gadījumā, ja tr/l tiek nozagts kopā ar dokumentiem, atslēgu, drošības sistēmu pultīm, kartēm",
//       },
//       {
//         insurerName: "Ergo",
//         insurerText:
//           "Ergo-Atlīdzība gadījumā, ja tr/l tiek nozagts kopā ar dokumentiem, atslēgu, drošības sistēmu pultīm, kartēm",
//       },
//       {
//         insurerName: "IF",
//         insurerText:
//           "IF-Atlīdzība gadījumā, ja tr/l tiek nozagts kopā ar dokumentiem, atslēgu, drošības sistēmu pultīm, kartēm",
//       },
//       {
//         insurerName: "Gjensidige",
//         insurerText:
//           "Gjensidige-Atlīdzība gadījumā, ja tr/l tiek nozagts kopā ar dokumentiem, atslēgu, drošības sistēmu pultīm, kartēm",
//       },
//       {
//         insurerName: "BTA",
//         insurerText:
//           "BTA-Atlīdzība gadījumā, ja tr/l tiek nozagts kopā ar dokumentiem, atslēgu, drošības sistēmu pultīm, kartēm",
//       },
//       {
//         insurerName: "Compensa",
//         insurerText:
//           "Compensa-Atlīdzība gadījumā, ja tr/l tiek nozagts kopā ar dokumentiem, atslēgu, drošības sistēmu pultīm, kartēm",
//       },
//       {
//         insurerName: "Balcia",
//         insurerText:
//           "Balcia-Atlīdzība gadījumā, ja tr/l tiek nozagts kopā ar dokumentiem, atslēgu, drošības sistēmu pultīm, kartēm",
//       },
//     ],
//   },
//   {
//     cascoConditionId: 15,
//     name: "Transportēšana (tr/l līdz 3,5t) līdz tuvākajai stāvvietai vai remontdarbnīcai pēc negadījuma",
//     insurerConditions: [
//       {
//         insurerName: "Balta",
//         insurerText:
//           "Balta-Transportēšana (tr/l līdz 3,5t) līdz tuvākajai stāvvietai vai remontdarbnīcai pēc negadījuma",
//       },
//       {
//         insurerName: "BAN",
//         insurerText:
//           "BAN-Transportēšana (tr/l līdz 3,5t) līdz tuvākajai stāvvietai vai remontdarbnīcai pēc negadījuma",
//       },
//       {
//         insurerName: "Ergo",
//         insurerText:
//           "Ergo-Transportēšana (tr/l līdz 3,5t) līdz tuvākajai stāvvietai vai remontdarbnīcai pēc negadījuma",
//       },
//       {
//         insurerName: "IF",
//         insurerText:
//           "IF-Transportēšana (tr/l līdz 3,5t) līdz tuvākajai stāvvietai vai remontdarbnīcai pēc negadījuma",
//       },
//       {
//         insurerName: "Gjensidige",
//         insurerText:
//           "Gjensidige-Transportēšana (tr/l līdz 3,5t) līdz tuvākajai stāvvietai vai remontdarbnīcai pēc negadījuma",
//       },
//       {
//         insurerName: "BTA",
//         insurerText:
//           "BTA-Transportēšana (tr/l līdz 3,5t) līdz tuvākajai stāvvietai vai remontdarbnīcai pēc negadījuma",
//       },
//       {
//         insurerName: "Compensa",
//         insurerText:
//           "Compensa-Transportēšana (tr/l līdz 3,5t) līdz tuvākajai stāvvietai vai remontdarbnīcai pēc negadījuma",
//       },
//       {
//         insurerName: "Balcia",
//         insurerText:
//           "Balcia-Transportēšana (tr/l līdz 3,5t) līdz tuvākajai stāvvietai vai remontdarbnīcai pēc negadījuma",
//       },
//     ],
//   },
//   {
//     cascoConditionId: 16,
//     name: "Tehniskā palīdzība (autopalīdzība) tr/l līdz 3,5t",
//     insurerConditions: [
//       {
//         insurerName: "Balta",
//         insurerText: "Balta-Tehniskā palīdzība (autopalīdzība) tr/l līdz 3,5t",
//       },
//       {
//         insurerName: "BAN",
//         insurerText: "BAN-Tehniskā palīdzība (autopalīdzība) tr/l līdz 3,5t",
//       },
//       {
//         insurerName: "Ergo",
//         insurerText: "Ergo-Tehniskā palīdzība (autopalīdzība) tr/l līdz 3,5t",
//       },
//       {
//         insurerName: "IF",
//         insurerText: "IF-Tehniskā palīdzība (autopalīdzība) tr/l līdz 3,5t",
//       },
//       {
//         insurerName: "Gjensidige",
//         insurerText:
//           "Gjensidige-Tehniskā palīdzība (autopalīdzība) tr/l līdz 3,5t",
//       },
//       {
//         insurerName: "BTA",
//         insurerText: "BTA-Tehniskā palīdzība (autopalīdzība) tr/l līdz 3,5t",
//       },
//       {
//         insurerName: "Compensa",
//         insurerText:
//           "Compensa-Tehniskā palīdzība (autopalīdzība) tr/l līdz 3,5t",
//       },
//       {
//         insurerName: "Balcia",
//         insurerText: "Balcia-Tehniskā palīdzība (autopalīdzība) tr/l līdz 3,5t",
//       },
//     ],
//   },
//   {
//     cascoConditionId: 17,
//     name: "Zaudējumi, kas radušies iebraucot peļķēs, applūdušās brauktuvēs",
//     insurerConditions: [
//       {
//         insurerName: "Balta",
//         insurerText:
//           "Balta-Zaudējumi, kas radušies iebraucot peļķēs, applūdušās brauktuvēs",
//       },
//       {
//         insurerName: "BAN",
//         insurerText:
//           "BAN-Zaudējumi, kas radušies iebraucot peļķēs, applūdušās brauktuvēs",
//       },
//       {
//         insurerName: "Ergo",
//         insurerText:
//           "Ergo-Zaudējumi, kas radušies iebraucot peļķēs, applūdušās brauktuvēs",
//       },
//       {
//         insurerName: "IF",
//         insurerText:
//           "IF-Zaudējumi, kas radušies iebraucot peļķēs, applūdušās brauktuvēs",
//       },
//       {
//         insurerName: "Gjensidige",
//         insurerText:
//           "Gjensidige-Zaudējumi, kas radušies iebraucot peļķēs, applūdušās brauktuvēs",
//       },
//       {
//         insurerName: "BTA",
//         insurerText:
//           "BTA-Zaudējumi, kas radušies iebraucot peļķēs, applūdušās brauktuvēs",
//       },
//       {
//         insurerName: "Compensa",
//         insurerText:
//           "Compensa-Zaudējumi, kas radušies iebraucot peļķēs, applūdušās brauktuvēs",
//       },
//       {
//         insurerName: "Balcia",
//         insurerText:
//           "Balcia-Zaudējumi, kas radušies iebraucot peļķēs, applūdušās brauktuvēs",
//       },
//     ],
//   },
//   {
//     cascoConditionId: 18,
//     name: "Atlīdzība par nozagtu atslēgu, drošības sistēmu izgatavošanu",
//     insurerConditions: [
//       {
//         insurerName: "Balta",
//         insurerText:
//           "Balta-Atlīdzība par nozagtu atslēgu, drošības sistēmu izgatavošanu",
//       },
//       {
//         insurerName: "BAN",
//         insurerText:
//           "BAN-Atlīdzība par nozagtu atslēgu, drošības sistēmu izgatavošanu",
//       },
//       {
//         insurerName: "Ergo",
//         insurerText:
//           "Ergo-Atlīdzība par nozagtu atslēgu, drošības sistēmu izgatavošanu",
//       },
//       {
//         insurerName: "IF",
//         insurerText:
//           "IF-Atlīdzība par nozagtu atslēgu, drošības sistēmu izgatavošanu",
//       },
//       {
//         insurerName: "Gjensidige",
//         insurerText:
//           "Gjensidige-Atlīdzība par nozagtu atslēgu, drošības sistēmu izgatavošanu",
//       },
//       {
//         insurerName: "BTA",
//         insurerText:
//           "BTA-Atlīdzība par nozagtu atslēgu, drošības sistēmu izgatavošanu",
//       },
//       {
//         insurerName: "Compensa",
//         insurerText:
//           "Compensa-Atlīdzība par nozagtu atslēgu, drošības sistēmu izgatavošanu",
//       },
//       {
//         insurerName: "Balcia",
//         insurerText:
//           "Balcia-Atlīdzība par nozagtu atslēgu, drošības sistēmu izgatavošanu",
//       },
//     ],
//   },
//   {
//     cascoConditionId: 19,
//     name: "Jaunvērtība",
//     insurerConditions: [
//       {
//         insurerName: "Balta",
//         insurerText: "Balta-Jaunvērtība",
//       },
//       {
//         insurerName: "BAN",
//         insurerText: "BAN-Jaunvērtība",
//       },
//       {
//         insurerName: "Ergo",
//         insurerText: "Ergo-Jaunvērtība",
//       },
//       {
//         insurerName: "IF",
//         insurerText: "IF-Jaunvērtība",
//       },
//       {
//         insurerName: "Gjensidige",
//         insurerText: "Gjensidige-Jaunvērtība",
//       },
//       {
//         insurerName: "BTA",
//         insurerText: "BTA-Jaunvērtība",
//       },
//       {
//         insurerName: "Compensa",
//         insurerText: "Compensa-Jaunvērtība",
//       },
//       {
//         insurerName: "Balcia",
//         insurerText: "Balcia-Jaunvērtība",
//       },
//     ],
//   },
//   {
//     cascoConditionId: 20,
//     name: "Vadītāja nelaimes gadījumu apdrošināšana",
//     insurerConditions: [
//       {
//         insurerName: "Balta",
//         insurerText: "Balta-Vadītāja nelaimes gadījumu apdrošināšana",
//       },
//       {
//         insurerName: "BAN",
//         insurerText: "BAN-Vadītāja nelaimes gadījumu apdrošināšana",
//       },
//       {
//         insurerName: "Ergo",
//         insurerText: "Ergo-Vadītāja nelaimes gadījumu apdrošināšana",
//       },
//       {
//         insurerName: "IF",
//         insurerText: "IF-Vadītāja nelaimes gadījumu apdrošināšana",
//       },
//       {
//         insurerName: "Gjensidige",
//         insurerText: "Gjensidige-Vadītāja nelaimes gadījumu apdrošināšana",
//       },
//       {
//         insurerName: "BTA",
//         insurerText: "BTA-Vadītāja nelaimes gadījumu apdrošināšana",
//       },
//       {
//         insurerName: "Compensa",
//         insurerText: "Compensa-Vadītāja nelaimes gadījumu apdrošināšana",
//       },
//       {
//         insurerName: "Balcia",
//         insurerText: "Balcia-Vadītāja nelaimes gadījumu apdrošināšana",
//       },
//     ],
//   },
// ];
// API functions
export const getCascoConditions = async (): Promise<CascoCondition[]> => {
  const response = await api.get(CASCO_CONDITIONS_API_BASE);
  return response.data || [];
};

export const createCascoCondition = async (
  data: CreateCascoConditionRequest
): Promise<CreateCascoConditionResponse> => {
  const response = await api.post(CASCO_CONDITIONS_API_BASE, data);
  return response.data;
};

export const updateCascoConditions = async (
  data: UpdateCascoConditionsRequest[]
): Promise<void> => {
  await api.patch(CASCO_CONDITIONS_API_BASE, data);
};

export const deleteCascoCondition = async (
  cascoConditionId: number
): Promise<void> => {
  await api.delete(`${CASCO_CONDITIONS_API_BASE}/${cascoConditionId}`);
};

export const updateInsurerCascoConditions = async (
  data: UpdateInsurerCascoConditionsRequest[]
): Promise<void> => {
  await api.patch("settings/insurercascoconditions", data);
};

export const populateDefaultCascoConditions = async (): Promise<
  CascoCondition[]
> => {
  const response = await api.post<CascoCondition[]>(
    `${CASCO_CONDITIONS_API_BASE}/populatedefault`
  );
  return response.data;
};

// React Query hooks
export const useCascoConditions = (): UseQueryResult<CascoCondition[]> => {
  const { handleAddAxiosErrorNotification } = useNotificationHandler();

  const result = useQuery<CascoCondition[], Error>({
    queryKey: [QUERY_KEYS.cascoConditions],
    queryFn: getCascoConditions,
  });

  useEffect(() => {
    if (result.error) {
      handleAddAxiosErrorNotification(result.error);
    }
  }, [result.error, handleAddAxiosErrorNotification]);

  return result;
};

export const useCreateCascoCondition = () => {
  const queryClient = useQueryClient();
  const { handleAddAxiosErrorNotification } = useNotificationHandler();

  return useMutation<
    CreateCascoConditionResponse,
    Error,
    CreateCascoConditionRequest
  >({
    mutationFn: createCascoCondition,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.cascoConditions],
      });
    },
    onError: (error) => {
      handleAddAxiosErrorNotification(error);
    },
  });
};

export const useUpdateCascoConditions = () => {
  const queryClient = useQueryClient();
  const { handleAddAxiosErrorNotification } = useNotificationHandler();

  return useMutation<void, Error, UpdateCascoConditionsRequest[]>({
    mutationFn: updateCascoConditions,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.cascoConditions] });
    },
    onError: (error) => {
      handleAddAxiosErrorNotification(error);
    },
  });
};

export const useDeleteCascoCondition = () => {
  const queryClient = useQueryClient();
  const { handleAddAxiosErrorNotification } = useNotificationHandler();

  return useMutation<void, Error, number>({
    mutationFn: deleteCascoCondition,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.cascoConditions] });
    },
    onError: (error) => {
      handleAddAxiosErrorNotification(error);
    },
  });
};

export const useUpdateInsurerCascoConditions = () => {
  const queryClient = useQueryClient();
  const { handleAddAxiosErrorNotification } = useNotificationHandler();

  return useMutation<void, Error, UpdateInsurerCascoConditionsRequest[]>({
    mutationFn: updateInsurerCascoConditions,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.cascoConditions] });
    },
    onError: (error) => {
      handleAddAxiosErrorNotification(error);
    },
  });
};

export const usePopulateDefaultCascoConditions = () => {
  const queryClient = useQueryClient();
  const { handleAddAxiosErrorNotification } = useNotificationHandler();

  return useMutation<CascoCondition[], Error>({
    mutationFn: populateDefaultCascoConditions,
    onSuccess: (data) => {
      queryClient.setQueryData([QUERY_KEYS.cascoConditions], data);
    },
    onError: (error) => {
      handleAddAxiosErrorNotification(error);
    },
  });
};
